export class Controller {

    /** @ngInject */
    constructor(ContactService) {
        this.ContactService = ContactService;
    }

    $onInit() {
        this.reset();
    }

    reset() {
        this.message = {name: '', email: '', text: ''};
    }

    sendMessage() {
        this.ContactService
            .save(this.message).$promise
            .then(
                () => {
                    alert('Message sent successfully');
                    this.reset();
                },
                () => alert('Error occured!!!!')
            );
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/public/contact/contact.controller.js